<template>
  <div class="check-new-live-wrap">
    <div class="check-new-live-wrap">
      <div class="flex-row-box">
        <div class="left-box">我的节目</div>
        <div class="right-box">
          <!-- <el-input
        suffix-icon="search"
        placeholder="搜索节目名称"
        v-model="keyword"
        @change="getData"
        style="width: 220px;"></el-input> -->
        </div>
      </div>
      <div class="category-selector">
        <el-tabs v-model="selectedCategory" class="category-tabs-box" @tab-click="handleClickCategory">
          <el-tab-pane v-for="category in categoriesOptions" :key="category.value" :label="category.label"
            :name="category.value" />
        </el-tabs>
      </div>
      <!-- 列表 -->
      <template v-if="lists.length > 0">
        <div v-loading="loading" v-infinite-scroll="load" :infinite-scroll-delay="1000" :infinite-scroll-distance="200"
          :infinite-scroll-immediate="false" class="list-wrap">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="list-item-wrap" v-for="item in lists"
              :key="item.id">
              <!-- @click="handleChecked(item)" -->
              <el-card :class="{ 'list-item-current': getChecked(item.id) }" class="list-item">
                <template #header>
                  <div class="list-item-header">
                    <div class="left">
                      <span>{{ item.name }}</span>
                    </div>
                    <div class="right">
                      <el-checkbox v-model="checkedItems[item.id]" @change="handleChecked(item)" />
                    </div>
                  </div>
                </template>
                <el-image class="list-item-image" :src="item.backgroundUrl || undefined" :zoom-rate="1.2" :max-scale="7"
                  :min-scale="0.2" :initial-index="4" fit="cover">
                  <template #error>
                    <div class="image-slot">
                      <img src="@/assets/images/no-picture.png" />
                      <div class="no-image-text">暂无背景图</div>
                    </div>
                  </template>
                </el-image>
                <template #footer>
                  <div class="list-item-footer">
                    <div class="left">
                      <span v-if="activeTab == '2'">节目时长：{{ formatSecondsToTime(item.videoMakeDuration) }} {{
                        item.createTime }}</span>
                      <span v-if="activeTab == '1'">创建时间：{{ formatDate(item.createTime) }}</span>
                    </div>
                    <div class="right"></div>
                  </div>
                </template>
              </el-card>
            </el-col>
          </el-row>
          <div v-if="listNoMore" class="no-more-data">
            没有更多数据了....
          </div>
        </div>
      </template>
      <template v-else>
        <el-empty class="empty-wrap" description="该分类还未找到相关节目">
        </el-empty>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { getCategories } from '@/request/index.ts';
import { getAppLiveProgramPage } from '@/request/program';
import { createDecorator } from 'vue-class-component';

const props = defineProps({
  selectedPrograms: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['checked']);

const dialogVisible = ref(false); // 弹窗控制
const lists = ref([]); // 列表数据
const categoriesOptions = ref([]); // 分类选项
const loading = ref(false); // 加载状态
const listPageIndex = ref(1); // 列表页码
const listPageSize = ref(12); // 列表页大小
const activeTab = ref(1); // 当前选中的tab
const selectedCategory = ref(''); // 选中的分类
const listNoMore = ref(false); // 列表是否没有更多数据

const checkedItems = computed({
  get() {
    const checked = {};
    lists.value.forEach((item) => {
      // 根据 selectedPrograms 初始化每个项目的选中状态
      checked[item.id] = props.selectedPrograms.some((program) => program.id === item.id);
    });
    return checked;
  },
  set(value) {
    // 这个 setter 会在复选框状态变化时触发
    // 通常在这个上下文中不使用，因为我们通过 handleChecked 处理变化
  },
});

// onMounted(async () => {

//   // setTimeout(() => {
//   //   loading.value = false;
//   // }, 500);
// });
// loading.value = true;

// 处理选中
const handleChecked = (val) => {
  // console.log('handleChecked', val);
  emit('checked', val);
};

// 获取选中的节目
const getChecked = (id) => {
  return props.selectedPrograms.find((val) => val.id == id);
};

// 点击分类
const handleClickCategory = async (val) => {
  loading.value = true;
  listPageIndex.value = 1;
  listNoMore.value = false;
  selectedCategory.value = val.paneName;
  const data = await getLists();
  lists.value = data.list;
  loading.value = false;
};

// 加载更多
const load = async () => {
  console.log('load');
  if (listNoMore.value) {
    return;
  }
  if (!listNoMore.value) {
    loading.value = true;
  }
  ++listPageIndex.value;
  const data = await getLists();
  // 如果实际请求的数量少于当前数量，说明没有更多数据了
  if (data.list.length < listPageSize.value) {
    listNoMore.value = true;
  }
  lists.value = [...lists.value, ...data.list];
  loading.value = false;
};

//
const handleAddProgram = () => {
  dialogVisible.value = false;
  console.log('handleAddProgram');
};

// 打开弹窗
const openDialog = async () => {
  loading.value = true;
  dialogVisible.value = true;
  await getCategoryLists();
  const data = await getLists();
  lists.value = data.list;
  loading.value = false;
};

// 时间格式化
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear().toString().slice(-2); // 获取最后两位年份
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，加1并确保两位数
  const day = date.getDate().toString().padStart(2, '0'); // 日期确保两位数
  return `${year}-${month}-${day}`; // 格式为 'yy-mm-dd'
};

// 获取节目列表
const getLists = async (params = {}) => {
  try {
    loading.value = true;
    const res = await getAppLiveProgramPage({
      pageIndex: listPageIndex.value,
      pageSize: listPageSize.value,
      liveType: activeTab.value == 2 ? 1 : 2,
      categoriesId: selectedCategory.value,
      ...params
    });
    const { data } = res.data;
    return data;
  } catch (error) {
    ElMessage({
      message: '获取列表失败,请刷新界面',
      type: 'error',
    });
  } finally {
    setTimeout(() => {
      loading.value = false;
    }, 500);
  }
};

// 获取节目分类列表
const getCategoryLists = async () => {
  try {
    const response = await getCategories({
      pageIndex: 1, // 调整为0-based索引
      pageSize: 99999,
    });
    // 填充下拉菜单的选项
    categoriesOptions.value = response.data.data.list.map((val) => ({
      label: val.name,
      value: val.id,
    }));
    categoriesOptions.value.unshift({
      label: '全部',
      value: '',
    });
  } catch (error) {
    console.error(error);
    ElMessage({
      message: '获取分类失败,请刷新界面',
      type: 'error',
    });
  }
};

const handleCreated = async (params = { screen: '横屏' }) => {
  loading.value = true;
  await getCategoryLists();
  const data = await getLists(params);
  lists.value = data.list;
  loading.value = false;
};

handleCreated();

defineExpose({
  openDialog, handleCreated
});
</script>

<style lang="scss" scoped>
.check-new-live-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .dialog-content {
    min-height: 100px;
    /* Adjust based on content */
  }
}

.flex-row-box {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .left-box {
    font-size: 16px;
    color: #fff;
    font-weight: 600;
  }
}

:deep(.el-card__header) {
  padding: 5px 10px !important;
}

:deep(.el-card__footer) {
  padding: 10px !important;
}

:deep(.el-card__body) {
  padding: 16px !important;
}

.list-wrap {
  flex: 1;
  overflow: auto;
  padding: 0 10px;
  margin-left: -6px;
  box-sizing: border-box;

  .list-item-wrap {
    cursor: pointer;
    padding: 5px !important;

    .list-item {
      box-shadow: none;
      padding: 0px !important;
      background: none !important;
      border-radius: 6px;
      display: flex;
      flex-direction: column;

      ::v-deep .el-card__body {
        height: 200px;
      }

      .list-item-header {
        font-size: 14px;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .list-item-image {
        background-color: #262727;
        box-shadow: var(--el-box-shadow);
        border-radius: 8px;
        height: 100%;
        width: 100%;
      }

      .image-slot {
        display: flex;
        /* 使用flex布局 */
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 16px;
        box-sizing: border-box;

        img {
          background-size: cover;
          background-position: center;
          width: 200px;
          height: 200px;
          max-width: 100%;
          /* 确保图片不会超过容器宽度 */
          max-height: 100%;
        }

        .no-image-text {
          font-weight: 600;
          color: white;
          /* 文本颜色，根据背景调整 */
          font-size: 14px;
          /* 文本大小，根据需要调整 */
        }
      }

      .list-item-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          font-size: 12px;
          display: flex;
          align-items: center;
        }
      }

      &:hover {
        background-color: #313336 !important;
        // background: linear-gradient(90deg, #5654f9 0%, #7f54f9 100%) !important;
        // transform: translateY(-2px) !important;
      }
    }

    .list-item-current {
      background: linear-gradient(90deg, #5654f9 0%, #7f54f9 100%) !important;
      transform: translateY(-2px) !important;
    }
  }
}

/* 没有更多数据 */
.no-more-data {
  text-align: center;
  /* 文本居中显示 */
  color: #fff;
  /* 设置字体颜色为灰色 */
  font-size: 12px;
  /* 设置字体大小 */
  padding: 3px 0;
  /* 上下填充20px，左右填充0 */
  background: linear-gradient(90deg, #5654f9 0%, #7f54f9 100%);
}

/* 空数据 */
.empty-wrap {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
